import { create } from 'zustand';

const useExamStore = create((set) => ({
  currentExam: null,
  attempt: null,
  violations: [],
  messages: [],

  setExam: (exam) => set({ currentExam: exam }),

  setAttempt: (attempt) => set({ attempt }),

  addViolation: (violation) =>
    set((state) => ({
      violations: [...state.violations, violation]
    })),

  addMessage: (message) =>
    set((state) => ({
      messages: [...state.messages, message]
    })),

  clearExam: () =>
    set({
      currentExam: null,
      attempt: null,
      violations: [],
      messages: []
    })
}));

export default useExamStore;
